import PropTypes from 'prop-types'
import React, { Component } from 'react'

import BasePage from '../../base/components/BasePage'

export default class RootContainer extends Component {

  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ])
  }

  render() {

    return (
      <BasePage type="guidedTour">
        {this.props.children}
      </BasePage>
    )

  }
}



// WEBPACK FOOTER //
// ./src/guided-tour/containers/Root.js